import styled from "@emotion/styled";

export const StyledYoutubeVideoWrapper = styled.div`
  background-color: rgba(255, 255, 255, 0.7);

  span {
    display: flex;
  }
`;
